// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Page404-module__styles--yiEPl {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    height: 70vh;
}

.Page404-module__styles--yiEPl>p {
    font-size: 25px;
    color: #6f879c70;
    font-weight: 500;
}

.Page404-module__notFoundBox--sCYXF {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70vh;
}

.Page404-module__notFoundBox--sCYXF > h2 > span {
    font-size: 50px;
    color: #0054E6;
    font-weight: 600;
}

.Page404-module__notFoundBox--sCYXF > h2  {
    display: flex;
    flex-direction: column;
    font-size: 25px;
    color: #B5C4FF;
    font-weight: 500;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/page-404/Page404.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".styles {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-content: center;\r\n    align-items: center;\r\n    height: 70vh;\r\n}\r\n\r\n.styles>p {\r\n    font-size: 25px;\r\n    color: #6f879c70;\r\n    font-weight: 500;\r\n}\r\n\r\n.notFoundBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 70vh;\r\n}\r\n\r\n.notFoundBox > h2 > span {\r\n    font-size: 50px;\r\n    color: #0054E6;\r\n    font-weight: 600;\r\n}\r\n\r\n.notFoundBox > h2  {\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-size: 25px;\r\n    color: #B5C4FF;\r\n    font-weight: 500;\r\n    text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"styles": `Page404-module__styles--yiEPl`,
	"notFoundBox": `Page404-module__notFoundBox--sCYXF`
};
export default ___CSS_LOADER_EXPORT___;
